var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPolicyManagement = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.94,
    d: "M56.524 102.736h-10.08c-2.694-.004-4.878-2.183-4.89-4.876v-7.522c-3.725-.916-7.302-2.359-10.621-4.284l-5.237 5.233c-1.935 1.842-4.975 1.842-6.91 0l-7.11-7.14c-1.903-1.908-1.903-4.997 0-6.905l4.985-4.99c-2.118-3.368-3.728-7.03-4.78-10.869H5.104c-2.697 0-4.886-2.183-4.893-4.88v-10.08c.007-2.697 2.196-4.879 4.893-4.877h6.3c.903-4.076 2.428-7.99 4.52-11.604l-4.247-4.246c-1.904-1.91-1.904-5 0-6.91l7.11-7.14c1.941-1.826 4.969-1.826 6.91 0l4.019 4.02c3.658-2.29 7.653-3.991 11.84-5.04V5.103c0-2.7 2.188-4.89 4.889-4.893h10.08c2.695.01 4.874 2.198 4.872 4.893v5.544c4.186 1.044 8.18 2.745 11.835 5.04l4.02-4.02c1.94-1.829 4.972-1.829 6.913 0l7.14 7.14c1.901 1.911 1.901 4.999 0 6.91l-4.28 4.225c2.1 3.613 3.63 7.529 4.536 11.609h6.3c2.696 0 4.884 2.18 4.893 4.876v10.08c-.007 2.698-2.195 4.882-4.893 4.884h-6.779c-1.054 3.837-2.665 7.5-4.78 10.87l4.99 4.99c1.899 1.91 1.899 4.994 0 6.904l-7.14 7.14c-1.934 1.852-4.983 1.852-6.917 0l-5.204-5.241c-3.325 1.926-6.905 3.374-10.634 4.3v7.506c-.007 2.689-2.184 4.867-4.872 4.876z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.479,
    cy: 51.471,
    r: 28.451,
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89B6DE",
    d: "M63.504 38.888c-4.322-.097-7.295-1.138-11.483-4.704-.312-.262-.767-.262-1.08 0-4.2 3.566-7.16 4.62-11.482 4.704-.395.004-.716.323-.722.718V52.97c0 6.498 4.414 10.702 12.146 15.818.37.218.828.218 1.197 0 7.732-5.116 12.146-9.32 12.146-15.818V39.606c-.006-.395-.327-.714-.722-.718z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPolicyManagement, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/policy_management.c6c35c8e.svg";
export { ForwardRef as ReactComponent };